export const cilSpeech = ["24 24","<path d='M6.75 11.25h1.5v1.5h-1.5v-1.5z'></path><path d='M11.25 11.25h1.5v1.5h-1.5v-1.5z'></path><path d='M15.75 11.25h1.5v1.5h-1.5v-1.5z'></path><path d='M21.75 1.5h-19.5c-0.828 0.001-1.499 0.672-1.5 1.5v13.5c0.001 0.828 0.672 1.499 1.5 1.5h3v5.25h1.436l5.25-5.25h9.814c0.828-0.001 1.499-0.672 1.5-1.5v-13.5c-0.001-0.828-0.672-1.499-1.5-1.5h-0zM21.75 16.5h-10.436l-4.564 4.564v-4.564h-4.5v-13.5h19.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-speech.js
// module id = null
// module chunks = 